import { createContext, useContext } from "react"
import { ProjectContextValue } from "./projeto.types"

export const ProjectContext = createContext<ProjectContextValue | undefined>(undefined)

export function useProjetoContext(): ProjectContextValue {
  const context = useContext(ProjectContext)

  if (context === undefined) {
    throw new Error("useProjetoContext deve ser usado dentro de ProjectProvider")
  }

  return context
}
